import { Suspense } from 'react';

import { ApplicationContext } from '@upside/spa-shared-context';

import { AppContext } from 'context/App';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'style.css';

import { ForgotPassword } from 'components/ForgotPassword';
import { Layout } from 'components/Layout';
import { Login } from 'components/Login';
import { ResetPassword } from 'components/ResetPassword';
import { Success } from 'components/ResetPassword/Success';
import { SsoExchange } from 'components/SsoExchange';

import 'i18n';

type AppProps = {
  context: ApplicationContext;
};

export default function App({ context }: AppProps) {
  return (
    // This Suspense usage is recommended by react-i18next when loading translations (see https://react.i18next.com/latest/using-with-hooks#using-the-usetranslation-hook).
    // In our case it shouldn't show the fallback as the translations are loaded almost instantaneously, but adding this placeholder in to follow the best-practice.
    <Suspense fallback="Loading translations">
      <AppContext.Provider value={context}>
        <Layout>
          <BrowserRouter>
            <Routes>
              <Route
                path="/login/forgot-password/verify"
                element={<ResetPassword />}
              />

              <Route
                path="/login/forgot-password/success"
                element={<Success />}
              />

              <Route
                path="/login/create-password"
                element={<ResetPassword isNewUser />}
              />

              <Route
                path="/login/forgot-password"
                element={<ForgotPassword />}
              />

              <Route path="/login/sso/exchange" element={<SsoExchange />} />

              <Route path="*" element={<Login />} />
            </Routes>
          </BrowserRouter>
        </Layout>
      </AppContext.Provider>
    </Suspense>
  );
}
